import type { InferRequestType, InferResponseType } from 'hono/client';
import { type ApiClient, useFetch } from '../api';

type GetDeviceActionLog = ApiClient['v1']['devices'][':deviceId']['actions']['log']['$get'];
type DeviceActionLogQuery = InferRequestType<GetDeviceActionLog>['query'];
export type DeviceActionLogResponse = InferResponseType<GetDeviceActionLog, 200>;

export function useDeviceActionLog(deviceId: number, params: DeviceActionLogQuery = {}) {
  return useFetch<DeviceActionLogResponse>(
    `devices/${deviceId}/actions/log?${JSON.stringify(params)}`,
    (client) =>
      client.v1.devices[':deviceId'].actions.log.$get({
        param: { deviceId: deviceId.toString() },
        query: params,
      }),
    undefined,
    { keepPreviousData: true }
  );
}
